import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateUserHasPlusDto {
  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? value : toCents(value)))
  unitPrice?: number;
}
